import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select/dist/declarations/src/Select';
import { CustomFilter } from '../../../../components/CustomFilter';
import ReactSelect from 'react-select';
import { initialFilterAccounts } from '../../utils/utils';
import { FilterBadge } from '../../../../models/FilterBadge';
import { CustomBadgeFilter } from '../../../../components/CustomBadgeFilter';

const activeOptions = [
  { value: true, label: 'Active' },
  { value: false, label: 'Inactive' },
];
interface PropsFilter {
  queryParams: any;
  setQueryParams: any;
}
export function AccountsFilter({ setQueryParams, queryParams }: PropsFilter) {
  // Filter States
  const [isActive, setIsActive] = useState<boolean | null>();
  const isActiveRef = useRef<null | Select>(null);

  // Get initial values from the url
  useEffect(() => {
    let clearFilters = [];

    if (queryParams.active || !queryParams.active) {
      setIsActive(queryParams.active);
      if (queryParams.active === true || queryParams.active === false) {
        updateBadge(
          'active',
          queryParams.active === true
            ? 'Active'
            : queryParams.active === false
            ? 'Inactive'
            : '',
          isActiveRef
        );
      } else {
        clearFilters.push('active');
      }
    }

    if (clearFilters.length >= 1) {
      clearMultipleFilter(clearFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams]);

  const handleIsActive = (params: any) => {
    if (params) {
      setIsActive(params.value);
    } else {
      setIsActive(undefined);
    }
  };
  const resetFilters = () => {
    // Clear All Ref
    isActiveRef.current?.clearValue();
    // Update QueryParams: Review if
    setQueryParams({ ...initialFilterAccounts });
  };

  const applyFilter = () => {
    const newQueryParams = { ...queryParams };
    newQueryParams.active = isActive;
    newQueryParams.pageNumber = 1;
    setQueryParams(newQueryParams);
  };

  /** START Filter Badges */
  const [filterBadges, setFilteBadges] = useState<FilterBadge[]>([]);
  const clearMultipleFilter = (filters: Array<string>) => {
    let badges = filterBadges;
    filters.forEach((element) => {
      badges = badges.filter((item: FilterBadge) => item.key !== element);
    });
    setFilteBadges(badges);
  };
  const clearFilter = (ref: any, keyParam: string) => {
    if (
      keyParam === 'accountId' ||
      keyParam === 'clientId' ||
      keyParam === 'franchiseId'
    ) {
      clearMultipleFilter([
        'accountId',
        'clientId',
        'franchiseId',
        'locationId',
      ]);
      let params = { ...queryParams };
      params['accountId'] = undefined;
      params['clientId'] = undefined;
      params['franchiseId'] = undefined;
      params['locationId'] = undefined;
      // When removing a badge you should be redirected to page 1.
      params['pageNumber'] = 1;
      setQueryParams(params);

      filterBadges
        .find((element) => element.key === 'accountId')
        ?.ref.current?.clearValue();
      filterBadges
        .find((element) => element.key === 'clientId')
        ?.ref.current?.clearValue();
      filterBadges
        .find((element) => element.key === 'franchiseId')
        ?.ref.current?.clearValue();
      filterBadges
        .find((element) => element.key === 'locationId')
        ?.ref.current?.clearValue();
    } else if (ref) {
      ref.current?.clearValue();
      let params = { ...queryParams };
      params[keyParam] = undefined;
      // When removing a badge you should be redirected to page 1.
      params['pageNumber'] = 1;
      setQueryParams(params);
    }

    setFilteBadges(
      filterBadges.filter((item: FilterBadge) => item.key !== keyParam)
    );
  };
  const updateBadge = (key: string, value: string, ref: any) => {
    let badges = filterBadges;
    const finded = badges?.find((item: FilterBadge) => item.key === key);
    if (finded && finded !== undefined) {
      badges.splice(badges.indexOf(finded), 1, {
        key: key,
        value: value,
        ref: ref,
      });
    } else {
      badges.push({
        key: key,
        value: value,
        ref: ref,
      });
    }
    setFilteBadges(badges);
  };

  /** END Filter Badges */

  return (
    <>
      {filterBadges?.map((item: FilterBadge) => {
        if (item.value && item.value !== '')
          return (
            <CustomBadgeFilter
              text={item.value}
              key={item.key}
              badgeKey={item.key}
              clearFilter={() => {
                if (item.ref) clearFilter(item.ref, item.key);
              }}
            ></CustomBadgeFilter>
          );
        else return <></>;
      })}
      <CustomFilter applyFilters={applyFilter} resetFilters={resetFilters}>
        <div onClick={(e) => e.stopPropagation()}>
          <label className='form-label fw-bold'>Active</label>
          <ReactSelect
            placeholder={<FormattedMessage id='COMMON.ALL' />}
            isClearable
            name='isActive'
            id='isActive'
            onChange={handleIsActive}
            options={activeOptions}
            value={
              activeOptions
                ? activeOptions.filter((x: any) => x.value === isActive)[0]
                : null
            }
            ref={isActiveRef}
            defaultValue={activeOptions[0]}
          />
        </div>
        {/* Add more filters */}
      </CustomFilter>
    </>
  );
}
